import { Tag, TagLabel, TagLeftIcon } from '@chakra-ui/react';
import React, { useMemo } from 'react';

import { Icon } from '~/packages/common-frontend/components/icons';
import { ColorScheme } from '~/packages/common-frontend/theme';
import { InvoiceComputedStatus } from '~/packages/invoices/ui/utils';

type InvoiceBadgeDetails = {
  label: string;
  colorScheme: ColorScheme;
  icon: string;
};

const invoiceStatusMap: Record<InvoiceComputedStatus, InvoiceBadgeDetails> = {
  created: {
    label: 'Created',
    colorScheme: 'blue',
    icon: 'calendar-clock',
  },
  scheduled: {
    label: 'Scheduled',
    colorScheme: 'blue',
    icon: 'calendar-clock',
  },
  dueSoon: {
    label: 'Due Soon',
    colorScheme: 'orange',
    icon: 'calendar-clock',
  },
  overdue: {
    label: 'Overdue',
    colorScheme: 'red',
    icon: 'calendar-clock',
  },
  paid: {
    label: 'Paid',
    colorScheme: 'green',
    icon: 'circle-check',
  },
  canceled: {
    label: 'Canceled',
    colorScheme: 'gray',
    icon: 'circle-check',
  },
};

type InvoiceStatusBadgeProps = {
  computedStatus: InvoiceComputedStatus;
  useBackgroundColors?: boolean;
};
export const InvoiceStatusBadge = ({
  computedStatus,
  useBackgroundColors = true,
}: InvoiceStatusBadgeProps) => {
  const invoiceBadgeDetails: InvoiceBadgeDetails = useMemo(() => {
    return invoiceStatusMap[computedStatus];
  }, [computedStatus]);

  return (
    <Tag
      colorScheme={invoiceBadgeDetails.colorScheme}
      variant={useBackgroundColors ? 'solid-muted' : 'ghost'}
    >
      <TagLeftIcon>
        <Icon icon={invoiceBadgeDetails.icon} />
      </TagLeftIcon>
      <TagLabel>{invoiceBadgeDetails.label}</TagLabel>
    </Tag>
  );
};
